<template>
  <button class="toggle-pill" :class="{ 'toggle-pill--on': value }" @click="toggle" type="button" :aria-pressed="value" :disabled="disabled">
    <span class="toggle-pill__track"></span>
    <span class="toggle-pill__thumb"></span>
  </button>
</template>

<script>
export default {
  name: "TogglePill",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggle() {
      this.$emit("input", !this.value);
    },
  },
};
</script>

<style scoped>
.toggle-pill {
  position: relative;
  width: 44px;
  height: 24px;
  background: #e0e0e0;
  border-radius: 12px;
  border: none;
  outline: none;
  cursor: pointer;
  transition: background 0.2s;
  padding: 0;
  display: inline-flex;
  align-items: center;
}
.toggle-pill__track {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border-radius: 12px;
  background: #e0e0e0;
  transition: background 0.2s;
}
.toggle-pill__thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: left 0.2s, background 0.2s;
}
.toggle-pill--on .toggle-pill__track {
  background: rgba(30, 64, 175);
}
.toggle-pill--on .toggle-pill__thumb {
  left: 22px;
  background: #fff;
}
.toggle-pill[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}
</style>
